export default {
  props: {
    // 组件名称
    componentName: {
      default: 'Ceiling',
      type: String,
    },
    // 组件类型
    componentType: {
      default: 0,
      type: Number,
    },
    // 组件标题
    componentTitle: {
      default: '',
      type: String,
    },
    // text
    copywriting: {
      default: 'Summer camps are filling up fast! Reserve your spot now!',
      type: String,
    },
    skip: {
      default: '_blank',
      type: String,
    },
    skipLink: {
      default: '',
      type: String,
    },
    skipWay: {
      default: '_blank',
      type: String,
    },
  },
  computed: {
    isLogin() {
      return this.$store.state.ucenter.isLogin;
    },
  },
}
